import { getPortalId } from '../../../../utils/getPortalId';
import { IS_SANDBOX_PORTAL_STORE_KEY, SANDBOX_DATA_STORE_KEY } from './store';
const isValidIsSandboxPortalConfig = cachedData => {
  return typeof cachedData === 'boolean';
};
const isValidSandboxDataConfig = obj => {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  const config = obj;
  if (config.sandboxHubId !== undefined && (typeof config.sandboxHubId !== 'number' || config.sandboxHubId !== getPortalId())) {
    return false;
  }
  if (config.parentHubId !== undefined && typeof config.parentHubId !== 'number') {
    return false;
  }
  if (config.type !== undefined && (typeof config.type !== 'string' || config.type !== 'STANDARD' && config.type !== 'DEVELOPER')) {
    return false;
  }
  if (config.version !== undefined && (typeof config.version !== 'string' || config.version !== 'V1' && config.version !== 'V2')) {
    return false;
  }
  return true;
};
const allSandboxDataIsPopulated = config => {
  return config && !!config.type && !!config.version && !!config.parentHubId && !!config.sandboxHubId;
};
export const cachedDataIsValid = (key, cachedData) => {
  if (key === IS_SANDBOX_PORTAL_STORE_KEY) return isValidIsSandboxPortalConfig(cachedData);
  if (key === SANDBOX_DATA_STORE_KEY) {
    return isValidSandboxDataConfig(cachedData) && allSandboxDataIsPopulated(cachedData);
  }
  return false;
};